"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.base64Encode = exports.base64Decode = void 0;

var _jsBase = require("js-base64");

var base64Decode = function base64Decode(str) {
  return _jsBase.Base64.decode(str);
};

exports.base64Decode = base64Decode;

var base64Encode = function base64Encode(str) {
  return _jsBase.Base64.encode(str);
};

exports.base64Encode = base64Encode;